import SuperRepository from '../superRepository'

export default new (class ReportTemplateRepository extends SuperRepository {
  baseUri() {
    return 'report_template'
  }
  exportReport = async ({ id, ...data }, params) =>
    this.httpClient().postFile(`${this.baseUri()}/${id}/export`, data, params)
})()
